<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct1p" id="p0009-01-0"><a id="page3"></a><a href="#/contents#fn_2" id="sn_2">DAY 2</a></p>
<p class="ct1"><a href="#/contents#fn_2">“LET . . .”</a></p>
<p class="ext"><span><i>God said, “Let the land produce vegetation: seed-bearing plants and trees on the land that bear fruit with seed in it, according to their various kinds.” And it was so.</i></span></p>
<p class="txr"><span><span class="small">GENESIS</span> 1:11–13</span></p>
<p class="tx1" id="p0009-04-4"><span class="dcap">T</span>he simple statement “Let the land produce vegetation” belies the almost unimaginable complexity needed for the task.</p>
<p class="tx">Plants need water and the God-designed water cycle—evaporation, condensation, precipitation. Plants need sunlight, and God had placed the earth the perfect distance from the sun so that this planet could sustain life. God created different plants for warm and wet and cool and dry climates. Plants need a constant source of carbon monoxide—and the animals God was planning needed a constant source of oxygen. The perfect symbiotic relationship—per God’s design.</p>
<p class="tx">God also saw that each plant had the right nutrients, the ideal temperature, and the necessary protection from the elements. “Let the land produce vegetation”—those simple words hardly suggest the intricacy, the complexity, of God’s creation, and they don’t begin to explain the mystery of the spark of life existing in every seed.</p>
<p class="tx3">WHAT KIND OF POWER ARE YOU SPEAKING INTO PEOPLE’S LIVES WITH YOUR WORDS—CREATIVE POWER OR DESTRUCTIVE?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter5.vue?fc87667c